import { setUser as setSentryUser } from '@sentry/react';
import { useEffect } from 'react';
import { useSentryAnalytics } from 'hooks/use-sentry-analytics.hook';

export const useAnalytics = (): void => {
  const analytics = useSentryAnalytics();

  useEffect(() => {
    // Sentry only indexes a top-level `id` as the searchable user id; without it the uuid stays
    // buried in `visitor` and `user.id:<uuid>` matches nothing.
    setSentryUser(analytics ? { ...analytics, id: analytics.visitor?.id } : null);
  }, [analytics]);
};
